<template>
  <MatrizValores />
</template>

<script>
import MatrizValores from '@/views/modules/financial/matricial/MatrizValores.vue'

export default {
  components: {
    MatrizValores,
  },
}
</script>
